import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AriannaNekonsolidovaniComponent } from './arianna-nekonsolidovani.component';

import { TabsModule } from 'beyond-util';

@NgModule({
  declarations: [AriannaNekonsolidovaniComponent],
  entryComponents: [AriannaNekonsolidovaniComponent],
  exports: [AriannaNekonsolidovaniComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class AriannaNekonsolidovaniModule {}



// WEBPACK FOOTER //
// ./src/app/pages/arianna-nekonsolidovani/arianna-nekonsolidovani.module.ts